/* eslint-disable no-nested-ternary,import/no-unresolved */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { isMobile } from 'react-device-detect';
import { MAIN_ICON_COLORS } from 'assets/components';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';

import { currencies, exchange } from '../../../../utilities/constants';
import { formatNumber } from '../../../../utilities/formatHelpers';

import { CARD_TRANSACTION_FUNDING_SOURCES } from '../../queries';
import { BANK_REQUESTS_COINS } from '../../../Accounts/constants';
import {
  BUFFER_AUTHORIZATION_TYPES_MAP,
  CardMastercardTransactionStatuses,
  cardProviders,
  cardTransactionScreens,
} from '../../constants';
import { useUserCardProvider } from '../../../../utilities/sharedHooks/user';
import { USER_REGION_SETTINGS_QUERY_KEY } from '../../../../utilities/sharedQueries';
import { useSetting } from '../../../../utilities/sharedHooks/settings';
import { useUsEnv } from '../../../../utilities/sharedHooks/useUsEnv';

const CardTransactionDetails = ({ details, openScreen }) => {
  const { t: translate } = useTranslation();

  const { cardProvider } = useUserCardProvider();
  const { data: userRegionSettings } = useQuery(USER_REGION_SETTINGS_QUERY_KEY);

  const [cashbackInfoPopupShow, setCashbackInfoPopupShow] = useState(false);

  const { isUsEnv } = useUsEnv();

  const { data: transactionFundingSource, refetch: getFundingSources } = useQuery(
    [CARD_TRANSACTION_FUNDING_SOURCES, { transactionId: details.id }],
    {
      enabled: false,
    }
  );
  const [allowLoyaltyProgramToggle] = useSetting('app_features', 'feature_use_loyalty_program');

  const allowLoyaltyProgram = useMemo(
    () => !!(userRegionSettings?.allow_loyalty_program && allowLoyaltyProgramToggle),
    [allowLoyaltyProgramToggle, userRegionSettings]
  );

  useEffect(() => {
    if (details.id) {
      getFundingSources();
    }
  }, [details]);

  const fundingSources = useMemo(() => {
    if (transactionFundingSource && transactionFundingSource.length > 0) {
      transactionFundingSource.map((fundingSource) => {
        if (fundingSource?.is_cryptodraft_spending) {
          if (fundingSource?.source_currency?.toLowerCase() === BANK_REQUESTS_COINS.EUR) {
            fundingSource.source_currency = BANK_REQUESTS_COINS.EUROC;
          }
          if (
            fundingSource?.source_currency?.toLowerCase() === BANK_REQUESTS_COINS.USD ||
            (fundingSource?.source_currency?.toLowerCase() === BANK_REQUESTS_COINS.GBP &&
              cardProvider === cardProviders.MONAVATE)
          ) {
            fundingSource.source_currency = BANK_REQUESTS_COINS.USDT;
          }
        }
        return fundingSource;
      });
      return transactionFundingSource;
    }
    return [];
  }, [transactionFundingSource]);

  const showOnlyBasicInfo =
    details?.transactionStatus &&
    details?.transactionType &&
    (details?.transactionStatus === CardMastercardTransactionStatuses.DECLINED ||
      details?.transactionType === BUFFER_AUTHORIZATION_TYPES_MAP.AUTH_REFUND ||
      details?.transactionType === BUFFER_AUTHORIZATION_TYPES_MAP.POSITIVE_ADVICE_CREDIT);

  const isRefundTransaction =
    details?.transactionType === BUFFER_AUTHORIZATION_TYPES_MAP.AUTH_REFUND ||
    details?.transactionType === BUFFER_AUTHORIZATION_TYPES_MAP.POSITIVE_ADVICE_CREDIT;

  const [featurePayoutMonthlyCashbackRewardsAutomatically] = useSetting(
    'app_features',
    'feature_payout_monthly_cashback_rewards_automatically'
  );

  const renderCashbackInfoPopup = () => (
    <div
      style={{ bottom: '2.5rem', left: '-50%', width: '14.375rem' }}
      className="position-absolute shadow p-3 bg-disabled rounded border-1 text-center popup-info custom-popup-info">
      <i
        className="position-absolute shadow"
        style={{ bottom: '0', left: '50%', marginBottom: '-1rem', transform: 'rotate(90deg)' }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="15"
          viewBox="0 0 8 15"
          fill="none">
          <path d="M9.5 8L0.5 16L0.500002 0L9.5 8Z" fill={MAIN_ICON_COLORS.INFO_ARROW} />
        </svg>
      </i>

      <p className="text-white text-f6 text-start">
        {featurePayoutMonthlyCashbackRewardsAutomatically
          ? translate(
              isUsEnv
                ? 'transaction_cashback_popup_info_us_note'
                : 'transaction_cashback_popup_info_note'
            )
          : translate(
              isUsEnv
                ? 'transaction_manually_cashback_popup_info_us_note'
                : 'transaction_manually_cashback_popup_info_note'
            )}
      </p>
    </div>
  );

  return (
    <ModalBodyLayout
      isScrollable={isMobile}
      renderHeader={() => (
        <div className="d-flex flex-row-center justify-content-between">
          <b className="text-f5 text-dark me-auto">{translate('transaction_details_title')}</b>
          <p className="text-f6 text-shadow pe-4">{details?.date}</p>
        </div>
      )}>
      <div className="bg-light rounded-extra d-flex flex-row p-3 justify-content-between align-items-center mt-4">
        <p className="text-dark text-f6">{translate('card_tab_label')}</p>
        <p className="text-dark text-f6">{details?.panLast4 || details?.PAN}</p>
      </div>

      <div className="bg-light rounded-extra p-3 mt-2">
        {details?.transactionType && (
          <div className="d-flex flex-row justify-content-between align-items-center">
            <p className="text-dark text-f6">{translate('transaction_details_type')}</p>
            <p className="text-dark text-f6">{details?.transactionType}</p>
          </div>
        )}
        {details?.transactionStatus && (
          <div className="d-flex flex-row justify-content-between align-items-center mt-4 pt-2">
            <p className="text-dark text-f6">{translate('transaction_details_status')}</p>
            <span
              style={{ fontFamily: 'HM Alpha Mono' }}
              className={`text-center text-f6 px-2 py-1 rounded-1  border-0 cursor-pointer upper-case
              ${details.transactionStatus === 'pending' && 'bg-warning-light text-warning'}
              ${details.transactionStatus === 'completed' && 'bg-success-light text-success'}
              ${details.transactionStatus === 'declined' && 'bg-danger-light text-danger'}
          `}>
              {details?.transactionStatus}
            </span>
          </div>
        )}
        <div className="d-flex flex-row justify-content-between align-items-center mt-4 pt-2">
          <p className="text-dark text-f6">{translate('transaction_details_merchant')}</p>
          <p className="text-dark text-f6 ps-4 text-righ">{details?.merchant}</p>
        </div>
        <div className="d-flex flex-row justify-content-between align-items-center mt-4 pt-2">
          <p className="text-dark text-f6">{translate('transaction_details_amount')}</p>
          <p className="text-dark text-f6">{details?.displayAmount}</p>
        </div>
        {isRefundTransaction && fundingSources && fundingSources?.length > 0 && (
          <div className="d-flex flex-row justify-content-between align-items-center mt-4 pt-2">
            <p className="text-dark text-f6">{translate('transaction_details_credited_to')}</p>
            <p className="text-dark text-f6">{`${fundingSources[0]?.source_currency?.toUpperCase()} ${translate(
              'transaction_details_wallet_label'
            )}`}</p>
          </div>
        )}
        {!showOnlyBasicInfo && details?.additionalInfo && (
          <>
            <div className="d-flex flex-row justify-content-between align-items-center mt-4 pt-2">
              <p className="text-dark text-f6">
                {translate('transaction_details_orginal_currency_amount')}
              </p>
              <p className="text-dark text-f6">{details?.originalDisplayAmount}</p>
            </div>
            <div className="d-flex flex-row justify-content-between align-items-center mt-4 pt-2">
              <p className="text-dark text-f6">
                {translate('transaction_details_mastercard_exchange_rate')}
              </p>
              <p className="text-dark text-f6">{details?.mastercardMarketRate}</p>
            </div>
            {details.ecbMarketRate && (
              <>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4 pt-2">
                  <p className="text-dark text-f6">
                    {translate('transaction_details_ecb_exchange_rate')}
                  </p>
                  <p className="text-dark text-f6 text-nowrap">{details?.ecbMarketRate}</p>
                </div>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4 pt-2">
                  <p className="text-dark text-f6">
                    {translate('transaction_details_program_markup')}
                  </p>
                  <p className="text-dark text-f6">{details?.programMarkup}</p>
                </div>
              </>
            )}
          </>
        )}

        {!showOnlyBasicInfo && (
          <div className="d-flex flex-row justify-content-between align-items-start mt-4 pt-2">
            <p className="text-dark text-f6 d-flex align-items-start">
              {translate('transaction_details_funding_sources')}
            </p>
            <div
              className="d-flex flex-column align-items-end"
              style={{ overflowY: 'auto', maxHeight: '10rem' }}>
              {fundingSources &&
                fundingSources.map((item, index) => (
                  <div className="d-flex flex-row" key={item.source_currency}>
                    {item?.is_cryptodraft_spending && (
                      <p className="me-1 text-f6">
                        {translate('transaction_details_cryptodraft_label')}
                      </p>
                    )}
                    <p className={`text-f6 ${index !== fundingSources.length - 1 ? 'pb-3' : ''} `}>
                      {`${formatNumber(
                        item.display_amount *
                          currencies[item.source_currency.toUpperCase()].conversion,
                        item?.is_cryptodraft_spending
                          ? exchange.FIAT_VALUE
                          : currencies[item.source_currency.toUpperCase()].decimal
                      )} ${item.source_currency.toUpperCase()}`}
                    </p>
                  </div>
                ))}
              {(!fundingSources || fundingSources.length === 0) && <b className="text-f5">-</b>}
            </div>
          </div>
        )}

        {!showOnlyBasicInfo && allowLoyaltyProgram && (
          <div className="d-flex flex-row justify-content-between align-items-center mt-4 pt-2">
            <div className="d-flex flex-row justify-content-start align-items-center position-relative">
              <p className="text-dark text-f6">
                {translate(
                  isUsEnv
                    ? 'transaction_details_cashback_us_label'
                    : 'transaction_details_cashback_label'
                )}
              </p>
              <i
                className="icon icon-question-other text-shadow text-f4 cursor-pointer d-block text-hover-dimmed ms-2"
                role="button"
                aria-label="info"
                tabIndex={-1}
                onMouseEnter={!isMobile ? () => setCashbackInfoPopupShow(true) : () => {}}
                onMouseLeave={!isMobile ? () => setCashbackInfoPopupShow(false) : () => {}}
                onClick={
                  isMobile ? () => openScreen(cardTransactionScreens.CASHBACK_INFO) : () => {}
                }
                onKeyDown={() => {}}
              />
              {!isMobile && cashbackInfoPopupShow && renderCashbackInfoPopup()}
            </div>

            <p className="text-dark text-f6">{details?.cashbackAmount}</p>
          </div>
        )}
      </div>
    </ModalBodyLayout>
  );
};

export default CardTransactionDetails;

CardTransactionDetails.propTypes = {
  details: PropTypes.object.isRequired,
  openScreen: PropTypes.func.isRequired,
};
